import { casOpsApi, QueryTag } from '../api';
import { FenceType } from './geofencesApi';

export interface GeofencePinDropModel {
  ft: FenceType;
  stid: number; // Style ID
  rad: number; // Radius (metres). Should be > 0.
}

export const geofencePinDropApi = casOpsApi.injectEndpoints({
  endpoints: build => ({
    getGeofencePinDrop: build.query<GeofencePinDropModel, void>({
      query: () => `api/geofencesettings/pindrop`,
      providesTags: (result, error) => (result ? [QueryTag.GeofencePinDrop] : []),
    }),
    // The PATCH endpoint also returns the new settings in the response.
    editGeofencePinDrop: build.mutation<GeofencePinDropModel, GeofencePinDropModel>({
      query: body => ({
        url: `api/geofencesettings/pindrop`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (result, error) =>
        !error
          ? [
              QueryTag.GeofencePinDrop,
              QueryTag.GeofenceStyle, // Invalidate all cached styles responses (list and individual)
              QueryTag.GeofenceVersion,
            ]
          : [],
    }),
  }),
  overrideExisting: false,
});

export const { useGetGeofencePinDropQuery, useEditGeofencePinDropMutation } = geofencePinDropApi;
